import moment from 'moment';

type TActionCookie = {
    key: string;
    value?: string;
    expires?: string;
  };

  const getCookies = (key: string) => {
    const cookies = document.cookie
      .split('; ')
      .reduce((result: Record<string, string>, current) => {
        const entries = current.split('=');
        const key = entries[0];
        const value = entries[1];
        if (key && value) result[key] = value;
        return result;
      }, {});
    return cookies?.[key];
  };
  
  const setCookie = (data: TActionCookie[]) => {
    data.forEach(({ key, value, expires }) => {
      const defaultExpires = moment().add(20, 'years').toDate();

      document.cookie = `${key}=${value}; expires=${
        expires || defaultExpires.toUTCString()
      }; path=/`;
    });
  };
  
  const deleteCookie = (keys: string[]) => {
    keys.forEach((key) => (document.cookie = `${key}=; Max-Age=0; path=/`));
  };
  
  export { getCookies, setCookie, deleteCookie };
  
